import { useForm } from "react-hook-form";
import { CirclePlus } from "lucide-react";

import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import DialogBox from "../../../components/UI/DialogBox";
import SearchDropdown from "../../../components/UI/PageInput/SearchDropdown";
import successIcon from "../../../assets/icons/successIcon.svg";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import DateInput from "../../../components/UI/PageInput/DateInput";
import MultiCheckDropdown from "../../../components/UI/PageInput/MultiCheckDropdown";

const AddStationRepairForm = ({
  setup,
  sendData,
  successResponse,
  loading,
  navigate,
}) => {
  const {
    handleSubmit,
    setValue,
    control,
    watch,
    register,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      workDoneIds: [],
    },
  });

  const { workDoneIds, repairDate } = watch();

  const onSubmit = (data) => {
    sendData(data, reset);
  };

  return (
    <>
      <div className="form-container">
        <CenteredHeading title="Add Station Repair" />
        <form
          onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
        >
          <div className="form-border max-w-2xl mx-auto">
            <SearchDropdown
              name="stationId"
              label="Station Name *"
              keyName="name"
              id="id"
              options={setup.stations}
              setValue={setValue}
              control={control}
              selectedVal={watch("stationId")}
              error={errors.stationId}
              search={true}
              showOptionId={true}
            />
            <MultiCheckDropdown
              name="workDoneIds"
              label="Work Done *"
              keyName="name"
              keyId="id"
              options={setup.workDone}
              error={errors.workDoneIds}
              selectedOptions={workDoneIds}
              control={control}
            />
            <DateInput
              label="Repair Date *"
              name={"repairDate"}
              value={repairDate}
              setValue={setValue}
              register={{
                ...register("repairDate", {
                  required: "Please repair date",
                }),
              }}
              error={errors.repairDate}
              disableFutureDays={true}
            />
          </div>
          <div className="addBtn---wrap gap-2">
            <PrimaryButton
              btnText={!loading ? "Add Repair Work" : "Adding..."}
              loading={loading}
              Icon={CirclePlus}
              size={18}
            />
            <GrayButton btnText="Clear" width="w-40" onClick={() => reset()} />
          </div>
        </form>
      </div>
      {successResponse && (
        <DialogBox
          message={`Station Repair Work Created Successfully!`}
          messageIcon={successIcon}
          btnText="Ok"
          closeAction={() => navigate("/site/repair-work")}
        />
      )}
    </>
  );
};
export default AddStationRepairForm;
